/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Get_StartedInputs */

const en_mobile_get_started = /** @type {(inputs: Mobile_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Started`)
};

const es_mobile_get_started = /** @type {(inputs: Mobile_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comenzar`)
};

/**
* | output |
* | --- |
* | "Get Started" |
*
* @param {Mobile_Get_StartedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_get_started = /** @type {((inputs?: Mobile_Get_StartedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Get_StartedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_get_started(inputs)
	return en_mobile_get_started(inputs)
});